// extracted by mini-css-extract-plugin
export var description = "styles-module--description--547a1";